import React from 'react';
import { BasePage } from '@sm/webassets';
import { useLocation } from 'react-router-dom';
import SEO from '~pricing/components/SEO';
import useScript from '~pricing/hooks/useScripts';
import { EXTERNAL_SCRIPTS } from '~pricing/lib/constants';
import useMainStyles from './useStyles';
import { ROOT_PRICING_ROUTE } from '~shared/constants/pricing';
import useExperimentAssignment from '~pricing/hooks/useExperimentAssignment';

export default function Layout({ isIPPM, children }: { isIPPM?: boolean; children?: React.ReactNode }): JSX.Element {
  const { isPnPRefresh } = useExperimentAssignment();

  useScript(EXTERNAL_SCRIPTS);
  // GP-69 Needs full page width so having the 1400px max-width from Main breaks the ui
  const routerLocation = useLocation();
  const { Main, RefreshFullWidth } = useMainStyles();

  // TODO: When/if GP-69 is implemented into production, this logic will need to be modified to look for /pricing/enterprise page
  // in order to not apply the max width of 1400px
  const main = routerLocation.pathname.includes(ROOT_PRICING_ROUTE) ? Main : '';
  const width = isPnPRefresh ? RefreshFullWidth : '';

  const classes = `${main} ${width}`;

  return (
    <BasePage pageId="Pricing" legacyWeb="billweb" sticky={false} includeHeader={!isIPPM} includeFooter={!isIPPM}>
      <SEO noIndex={isIPPM}>
        <main className={classes}>{children}</main>
      </SEO>
    </BasePage>
  );
}
